import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import { TextFieldProps } from "@insite/mobius/TextField";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface ProductDetailsQuantityOrderedStyles {
    quantityOrdered?: TextFieldProps;
    container?: InjectableCss;
}

export const quantityOrderedStyles: ProductDetailsQuantityOrderedStyles = {
    quantityOrdered: {
        cssOverrides: {
            inputSelect: css`
                margin-top: 0px !important;
            `,
            formInputWrapper: css`
                margin-top: 0px !important;
                input {
                    background: ${getColor("secondary")} !important;
                    border: 1px solid ${getColor("text.accent")} !important;
                    text-align: center;
                    min-width: 65px;
                    padding-left: 0 !important;
                    padding-right: 0 !important;
                }
                input::-webkit-outer-spin-button,
                input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
                input[type="number"] {
                    -moz-appearance: textfield;
                }
            `,
            formField: css`
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-direction: row;
                label {
                    font-family: ${TYPOGRAPHY.fontFamily.title};
                    font-style: normal;
                    font-weight: ${TYPOGRAPHY.weight.bold};
                    font-size: ${TYPOGRAPHY.size.base};
                    line-height: ${TYPOGRAPHY.lineHeight.xbase};
                    color: ${getColor("text.main")};
                    width: 80%;
                    width: fit-content;
                    white-space: nowrap;
                }
            `,
        },
    },
    container: {
        css: css`
            width: auto;
            margin-bottom: 17.33px;
            div[class^="FormFieldStyle"] {
                padding-right: 22px;
            }
        `,
    },
};

const styles = quantityOrderedStyles;

const ProductDetailsQuantityOrdered = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
}: Props) => {
    return (
        <StyledWrapper {...styles.container}>
            <ProductQuantityOrdered
                configurationSelection={configurationSelection}
                configurationCompleted={configurationCompleted}
                variantSelectionCompleted={variantSelectionCompleted}
                extendedStyles={styles.quantityOrdered}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsQuantityOrdered)),
    definition: {
        displayName: "QTY Ordered",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
